<template>
 	<v-layout class="grid-our-products" align-center>
		<v-flex class="content-logo-company" v-for="(item, index) in logosCompany" :key="index">
			<img class="icon-products" :src="item.icon" alt="">
		</v-flex>
	</v-layout>
</template>

<script>
export default {
	name: 'logo-company',
	props: {
		logosCompany: {
			type: Array,
			default: () => [],
		},
		windowSize: {
			default: () => {},
			type: Object,
		},
	},
};
</script>
<style lang="scss" scoped>
.grid-our-products {
	align-self: center;
	display: grid;
	grid-column-gap: 184px;
	grid-row-gap: 73px;
	grid-template-columns: auto auto auto;
	margin: 95px auto 0 auto;

	@media (max-width: 1024px) {
		grid-column-gap: 33px;
		grid-row-gap: 44px;
		grid-template-columns: auto auto;
		margin: 45px auto 0 auto;
	}

	@media (max-width: 380px) {
		grid-template-columns: auto;
	}
}
.icon-products {
	height: 65px;
	width: 170px;

	@media (max-width: 1024px) {
		width: 120px;
	}
}

.content-logo-company:nth-child(7) {
	grid-column: 2 / 3;

	@media (max-width: 1024px) {
		grid-column: 1 / 3;
		margin-left: 50%;
		transform: translateX(-50%);
	}
}

.content-logo-company {
	opacity: 0.43;

	@media (max-width: 1024px) {
		opacity: 1;
	}

	&:hover {
		@media (min-width: 1024px) {
			transform: scale(1.05);
			transition: all ease-in-out .3s;
			opacity: 1;	
		}
	}
}

.icon-products {
	height: 65px;
	width: 170px;

	@media (max-width: 860px) {
		width: 130px;
	}
}

.icon-responsive {
	@media (max-width: 860px) {
		width: 94px;
	}
}

.icon-feedbackin {
	@media (max-width: 860px) {
		width: 142px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/home/logo-company.vue